<script setup>
import {ref, watch} from "vue";
import StartupHome from "@/views/startup/Profile.vue";
import EcosystemHome from "@/views/ecosystem/Home.vue";
import EnterpriseHome from "@/views/enterprise/home/Home.vue";
import Needs from "@/views/needs/needs/Needs.vue";
import NeedsDashboard from "@/views/enterprise/needsDashboard/NeedsDashboard.vue";
import {useStore} from "vue2-helpers/vuex";

const store = useStore();

const show = ref(false);

watch(() => store.getters.infoLoaded, (value) => {
    if (value) {
        show.value = true;
    }
}, {immediate: true});

</script>

<template>
    <div v-if="show">
        <template v-if="store.getters.isEnterprise">
            <template v-if="store.getters.onlyNeeds">
                <NeedsDashboard v-if="store.state.user.is_admin"/>
                <Needs v-else/>
            </template>

            <EnterpriseHome v-else/>
        </template>

        <ecosystem-home v-if="store.getters.isEcosystem"></ecosystem-home>
        <startup-home v-if="store.getters.isStartup"></startup-home>
    </div>
</template>

<style scoped>

</style>
